<style scoped>
	.layout {
		border: 1px solid #d7dde4;
		background: #f5f7f9;
		position: relative;
		border-radius: 4px;
		overflow: hidden;
	}

	.layout-logo {
		/* width: 9.375rem;
    height: 60px; */
		color: #ffffff !important;
		font-size: 30px;
		border-radius: 3px;
		float: left;
		/* position: relative; */
		/* left: -45px; */
		line-height: 30px;
		color: aliceblue;
		z-index: 9999;
	}

	.logo {
		/* margin-top: 10px; */
		width: 80px;
		height: 40px;
		float: left;
		line-height: 40px;
		/* 	background: url(../assets/logo.png) no-repeat;
	background-size: 100% auto; 
	background-position: 0px -20px; */
	}

	.layout-nav {
		width: 420px;
		/* margin: 0 auto; */
		margin-right: 20px;
	}

	.ivu-select-dropdown {
		background-color: #000000 !important;
	}

	.ivu-menu-light:after {
		height: 0px !important;
	}

	.ivu-menu-horizontal {
		background-color: transparent !important;
	}

	.ivu-menu-horizontal .ivu-menu-item {
		padding: 0 0.25rem;
	}

	.ivu-menu-item {
		font-size: 1.05rem;
	}
	
	.current-time {
		display: none;
	}
	@media (min-width: 1210px) {
		.current-time {
			display: block;
		}
	}
	.top-menu {
		display: none;
	}
	.top-menu-collapse {
		display: block;
	}
	.ivu-layout-header {
		height: 40px;
		line-height: 40px;
		padding: 0;
	}
	.ivu-layout-header-title {
		height: 40px;
		line-height: 40px;
		font-size: 1.1rem;
	}
	.ivu-menu-horizontal {
		height: 40px;
		line-height: 40px;
	}
	.ivu-layout-header-logo {
		height: 40px;
		line-height: 40px;
		width: 80px;
	}
	.ivu-layout-header-layout-nav {
		margin-right: 1rem;
		width:100%;
		font-size: 0.9rem !important;
	}
	.ivu-menu-item {
		font-size: 1.0rem !important;		
	}
	@media (min-width: 915px) {
		.top-menu {
			display: block !important;
		}
		.top-menu-collapse {
			display: none !important;
		}
		.ivu-layout-header {
		}
	}
	
	
	.ivu-menu-horizontal .ivu-menu-submenu {
		padding: 0 10px;
	}
</style>

<template>
	<div class="layout" style="height: 100%;width: 100%;">
		<Layout style="height: 100%;">
			<Header>
				<Row>
				<Col flex="220px" class="layout-logo">
					<div class="logo">
						<img class="ivu-layout-header-logo" :src="getLogo" />
						<!-- <img style="height: 60px;width: 80px;" v-else src="@/assets/station.png" /> -->
					</div>
					<div class="ivu-layout-header-title">
						<!-- {{CurrentUserInfo.LogoTitle}} -->
						主控板管理平台
					</div>
				</Col>
				<Col flex="auto">
					<Menu mode="horizontal" theme="dark" style="background-color: #080A1A;" :active-name="currentPath">
						<div class="layout-nav ivu-layout-header-layout-nav">
							<div class="top-menu">
								<template v-for="(item,itemIndex) in Menu">
									<router-link v-bind:key="itemIndex"
										v-bind:to="item.path" :target="item.path=='/StationOverview' ? '_blank' : '_self'">
										<MenuItem v-bind:name="item.path">
										<Icon type="ios-navigate"></Icon>
										{{item.topName}}
										</MenuItem>
									</router-link>
								</template>
							</div>
							<div class="top-menu-collapse">
								<Submenu name="submenu">
									<template slot="title">
										<Icon type="md-reorder"></Icon>
										菜单导航
									</template>
									<template v-for="(item,itemIndex) in Menu">
										<router-link v-bind:key="itemIndex"
											v-bind:to="item.path" :target="item.path=='/StationOverview' ? '_blank' : '_self'">
											<MenuItem v-bind:name="item.path">
											<Icon type="ios-navigate"></Icon>
											{{item.topName}}
											</MenuItem>
										</router-link>
									</template>
								</Submenu>
							</div>
						</div>
					</Menu>
					</Col>
					<Col flex="40px">
						<div style="height: 60px; width: 60px; text-align: center;">
							<!-- <img style="height: 16px;border-radius: 100px;margin-top: 18px;float: right;margin-left: 10px;"
								:src="CurrentUserInfo.HeadImg" /> -->
							<div style="color: #F0F8FF;margin-left: 0px;font-size: 0.8rem;">
								<Dropdown trigger="click" @on-click="headMethod">
									<!-- <a href="javascript:void(0)">
										{{CurrentUserInfo.DisplayName}}
										<Icon type="ios-arrow-down"></Icon>
									</a> -->
									<Avatar :style="{background: '#7265e6'}">{{ CurrentUserInfo.DisplayName }}</Avatar>
									<DropdownMenu slot="list" style="color: white;text-align: left;">
										<DropdownItem name="loginOut">退出登录</DropdownItem>
										<DropdownItem name="UpPass">修改密码</DropdownItem>
										<DropdownItem name="UpInfo">修改信息</DropdownItem>
									</DropdownMenu>
								</Dropdown>
							</div>
							<!-- <div v-if="timeShow" style="float: right;color: #F0F8FF;font-size: 0.7rem;">
								{{currentTime}}
							</div> -->
						</div>
				</Col>
				</Row>
			</Header>
			<MySiderLayout v-bind:Menu="Menu">
			</MySiderLayout>
			<!-- <router-view></router-view> -->
			<Modal v-model="modal.modalView" :title="modal.Title" width="20%" :mask-closable=false :closable='false'>
				<!--修改密码和信息-->
				<Form :rules="ruleInlinePass" label-position="right" v-if="modal.type=='UpPass'" ref="UpPassItem"
					:model="UpPassItem" :label-width="90">
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="旧密码:" prop="OldPassword">
							<Input type="password" :disabled="modal.canInput" v-model="UpPassItem.OldPassword"
								placeholder="输入旧密码"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="新密码" prop="NewPassword">
							<Input type="password" :disabled="modal.canInput" v-model="UpPassItem.NewPassword"
								placeholder="输入新密码"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="再次输入密码" prop="NewPassword2">
							<Input type="password" :disabled="modal.canInput" v-model="UpPassItem.NewPassword2"
								placeholder="再次输入密码"></Input>
						</FormItem>
						</Col>
					</Row>
				</Form>
				<Form :rules="ruleInlineInfo" label-position="right" v-if="modal.type=='UpInfo'" ref="UpInfoItem"
					:model="UpInfoItem" :label-width="90">
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="用户名称:" prop="DisplayName">
							<Input :disabled="modal.canInput" v-model="UpInfoItem.DisplayName"
								placeholder="输入用户名称"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="邮箱:" prop="Email">
							<Input :disabled="modal.canInput" v-model="UpInfoItem.Email" placeholder="输入邮箱"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="手机号码" prop="Phone">
							<Input :disabled="modal.canInput" v-model="UpInfoItem.Phone" placeholder="手机号码"></Input>
						</FormItem>
						</Col>
					</Row>
				</Form>
				<div slot="footer">
					<Button type="warning" size="large" @click="modalOk('cancel')">取消</Button>
					<Button type="success" size="large" @click="modalOk('ok')">确定</Button>
				</div>
			</Modal>
		</Layout>
	</div>
</template>

<script>
	import Menu from '../router.js';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../webapi.js';
	import Qs from "qs";
	import routerUtils from '../router.js';
	export default {
		data() {
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('再次输入密码'));
				} else {
					if (this.UpPassItem.NewPassword2 != this.UpPassItem.NewPassword) {
						callback(new Error('两次密码输入不一样'));
					} else {
						callback();
					}
				}
			};
			const validateInfo = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入电话号码'));
				} else {
					let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
					if (!myreg.test(value)) {
						callback(new Error('请输入合法电话号码'));
					} else {
						callback();
					}
				}
			};
			return {
				timer: '',
				timer2: '',
				//时间显示
				timeShow: false,
				login: true,
				selectMenu: '',
				Menu: [],
				currentTime: '',
				UserName: '',
				//modal 修改密码和信息参数
				modal: {
					Title: "重置密码",
					type: "UpInfo",
					modalView: false,
					canInput: false
				},
				UpPassItem: {
					OldPassword: '',
					NewPassword: '',
					NewPassword2: ''
				},
				ruleInlinePass: {
					NewPassword2: [{
						validator: validatePass,
						trigger: 'blur',
					}],
					OldPassword: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur',
					}],
					NewPassword: [{
						required: true,
						message: '请再次输入旧密码',
						trigger: 'blur'
					}],
				},
				ruleInlineInfo: {
					DisplayName: [{
						required: true,
						message: '请输入用户名称',
						trigger: 'blur'
					}],
					Email: [{
						required: true,
						message: '请输入邮件地址',
						trigger: 'blur',
						type: 'email'
					}],
					Phone: [{
						validator: validateInfo,
						trigger: 'blur'
					}],
				},
				UpInfoItem: {
					DisplayName: '',
					Email: '',
					Phone: ''
				},
				canLoadRoute: true,
			}
		},
		created() {
			const _this = this
			this.getUserMenus();
			window.addEventListener('resize', this.setHtml)
			window.addEventListener('resize', function() {
				if (document.body.clientWidth < 1270) {
					_this.timeShow = false
				} else {
					_this.timeShow = true
				}
			})
			this.UserName = localStorage.getItem("UserName")
			this.login = true
			this.timer = setInterval(function() {
				const d = new Date();
				const year = _this.addZero(d.getFullYear());
				const Mo = _this.addZero(d.getMonth() + 1);
				const day = _this.addZero(d.getDate());

				const h = _this.addZero(d.getHours());
				const m = _this.addZero(d.getMinutes());
				const s = _this.addZero(d.getSeconds());

				_this.currentTime = //修改数据date
					year + "-" + Mo + "-" + day + " " + h + ":" + m + ":" + s;
			}, 1000);
			console.log(localStorage.getItem("RefreshTokenTime") * 1000 - 1000);
			this.timer2 = setInterval(_this.getRefreshToken,60000);
			_this.timer3 = setInterval(_this.getVersion, 60000);
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
			if (this.timer2) {
				clearInterval(this.timer2); // 在Vue实例销毁前，清除我们的定时器
			}
			if (this.timer3) {
				clearInterval(this.timer3);
			}
		},
		mounted() {
			this.Menu = JSON.parse(localStorage.getItem("topMenus"));
			//vuex 公共站点列表	
			if (process.env.NODE_ENV === "development") {
				this.GetIcpOperator('127.0.0.1');
			} else {
				this.GetIcpOperator(window.location.href.split("/")[2]);
			}
			this.GetUserStations();
			this.GetEquipmentModelDefine();
			// this.GetPriceModelDefine();
			// this.GetPriceModelPowerDefine();
			this.GetTypeListDefine();
			this.GetRoleListDefine();
			this.GetCurrentUserInfo();
		},
		// 		watch:{
		// 			$route(to,from){
		// 				const path=to.path.split('/');
		// 				if(path.length==2){
		// 					for(let i=0;i<Menu.length;i++){
		// 						if(Menu[i].path=="/"+path[1]){
		// 							this.MenuList=[];
		// 							this.MenuList.push(Menu[i]);
		// 						}
		// 					}
		// 				}
		// 			}
		// 		},

		computed: {
			getLogo: function() {
				// if (process.env.NODE_ENV === "development") {
				// 	console.log("这里");
				// 	return 'http://' + window.location.href.split("/")[2] + '/ChargePlatform' + this.IcpOperator.LogoImg
				// } else {
				// 	console.log("这里");
				// 	return 'https://' + window.location.href.split("/")[2] + '/ChargePlatform' + this.IcpOperator.LogoImg
				// }
				if (!this.CurrentUserInfo || !this.CurrentUserInfo.LogoImg) return "";
				if (/https.*/i.test(this.CurrentUserInfo.LogoImg)) return this.CurrentUserInfo.LogoImg;
				if (this.CurrentUserInfo.LogoImg.substr(0, 1) != '/') this.CurrentUserInfo.LogoImg = '/' + this
					.CurrentUserInfo.LogoImg;
				return webapi.base_api_url + this.CurrentUserInfo.LogoImg
			},

			//直接选属性
			currentPath: function() {
				//console.log(this.$route.path.split('/')[1] )
				let select = '/' + this.$route.path.split('/')[1]
				let flag = this.Menu.some((item, index, array) => {
					//一满足查询条件就停止循环，返回bool
					return item.path == select;
				})
				if (flag) {
					this.selectMenu = select;
					return this.selectMenu;
				} else {
					return this.selectMenu;
				}
			},
			...mapState({
				IcpOperator: 'IcpOperator',
				CurrentUserInfo: 'CurrentUserInfo'
			})
		},
		methods: {
			...mapActions([
				'GetIcpOperator',
				'GetUserStations',
				'GetEquipmentModelDefine',
				// 'GetPriceModelDefine',
				// 'GetPriceModelPowerDefine',
				'GetTypeListDefine',
				'GetRoleListDefine',
				'GetCurrentUserInfo',
			]),

			headMethod: function(name) {
				console.log(name)
				switch (name) {
					case 'UpPass':
						this.modal.Title = "更新密码"
						this.modal.type = "UpPass"
						this.modal.modalView = true
						break;
					case 'UpInfo':
						this.modal.Title = "更新用户信息"
						this.modal.type = "UpInfo"
						this.UpInfoItem = this.CurrentUserInfo
						this.modal.modalView = true
						break;
					case 'loginOut':
						localStorage.removeItem('AccessToken')
						localStorage.removeItem('RefreshToken')
						localStorage.removeItem('UserName')
						localStorage.removeItem('UserMenus')
						localStorage.removeItem('topMenus')
						localStorage.removeItem('menuFlag')
						localStorage.clear();
						mapState.hasMenus = false;
						this.$router.push({
							name: 'login',
							params: {
								isLogout: 1
							}
						});
						break;
				}
			},

			modalOk: function(type) {
				switch (type) {
					case 'ok':
						this.upUserInfo()
						break;
					case 'cancel':
						this.modal.modalView = false
						break;
				}
			},
			getUserMenus() {
				const _this = this
				if (!this.canLoadRoute) return;
				this.canLoadRoute = false;
				return _this.$axios.post(webapi.base_api_url + "/Home/GetUserMenus", {}).then(res => {
					console.log("获得用户菜单", res)
					if (res.status == 200 && res.data.Code == 0) {
						localStorage.setItem("UserMenus", JSON.stringify(res.data.Data.List));
						setTimeout(() => {routerUtils.userRoute()}, 1000) ;
					} else {
						console.log("获得用户菜单错误")
					}
				})
			},
			upUserInfo: function() {
				const _this = this
				if (_this.modal.type == 'UpInfo') {
					_this.$refs.UpInfoItem.validate((valid) => {
						if (valid) {
							let parms = this.UpInfoItem
							_this.$axios.post(webapi.base_api_url + "/System/ModifyUserInfo", parms, {}).then(
								res => {
									console.log("用户信息修改", res.data)
									if (res.data.Code == 0) {
										this.$Message.success('用户信息修改成功');
										_this.modalOk("cancle")
									} else {
										this.$Message.success(res.data.Msg + "---" + res.data.Data);
									}
								})
						}
					})
				} else if (_this.modal.type == 'UpPass') {
					_this.$refs.UpPassItem.validate((valid) => {
						if (valid) {
							let parms = this.UpPassItem
							_this.$axios.post(webapi.base_api_url + "/System/ModifyUserPsw", parms, {}).then(
								res => {
									console.log("用户密码修改", res.data)
									if (res.data.Code == 0) {
										this.$Message.success('用户密码修改成功');
										_this.modalOk("cancle")
									} else {
										this.$Message.success(res.data.Msg + "---" + res.data.Data);
									}
								}).catch(function(error) {
								console.log(error.config);
							});
						}
					})
				}
			},

			addZero: function(i) {
				if (i < 10) {
					i = "0" + i;
				}
				return i;
			},

			setHtml: function(width) {
				console.log(document.body.clientWidth / 60 + 'px')
				document.getElementsByTagName('html')[0].style.fontSize = document.body.clientWidth / 60 + 'px';
			},
			getRefreshToken() {
				const _this = this
				let expireTime = Number(localStorage.getItem("AccessTokenExpires"));
				let dtExpire = new Date(expireTime);
				console.log('过期时间', dtExpire);
				if (new Date() < dtExpire) {
					return;
				}
				_this.$axios.post(webapi.base_api_url + "/Home/RefreshToken", {
					RefreshToken: localStorage.getItem("RefreshToken")
				}).then(res => {
					console.log("刷新token定时器2")
					if (res.data.Code == 0) {
						// console.log(res.data.Data.AccessToken)
						localStorage.setItem("AccessToken", res.data.Data.AccessToken);
						localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
						localStorage.setItem("RefreshTokenTime", res.data.Data.ExpiresIn)
						let curTime = new Date();
						let expireTime = curTime.valueOf() + (res.data.Data.ExpiresIn - 300) * 1000;
						console.log("过期时间", new Date(expireTime));
						localStorage.setItem("AccessTokenExpires", expireTime);
					} else {
						console.log("刷新token定时器请求错误")
						this.$router.push("/login")
					}
				})
			},
			getVersion() {
				const _this = this
				if (process.env.NODE_ENV === "development") {
					_this.$axios.get("/version.json", {}).then(res => {
						let lastVersion = res.data.version;
						console.log("查询版本", lastVersion);
						if (localStorage.version == undefined) {
							localStorage.setItem("version", lastVersion)
						} else {
							if (localStorage.version != lastVersion) {
								localStorage.removeItem("version")
								this.$Modal.info({
									title: "检测到版本更新，刷新页面！！",
									okText: '确定',
									onOk: () => {
										_this.$router.go(0)
									}
								});
							}
						}
					});
				} else {
					_this.$axios.get("/CMP/version.json", {
						params: {
							data: new Date()
						}
					}).then(res => {
						let lastVersion = res.data.version
						console.log("查询版本", lastVersion)
						if (localStorage.version == undefined) {
							localStorage.setItem("version", lastVersion)
						} else {
							if (localStorage.version != lastVersion) {
								localStorage.removeItem("version")
								_this.$router.go(0); // 刷新页面
								// this.$Modal.info({
								// 	title: "检测到版本更新，刷新页面！！",
								// 	okText: '确定',
								// 	onOk: () => {
								// 		_this.$router.go(0)
								// 	}
								// });
							}
						}
					});
				}
			}
		}
	}
</script>
